import { useEffect, useState } from "react";
import Residence from "./Residence";
import API_ROUTES from "../constants/apis";
import axios from "axios";
import Footer from "./Footer";
import Navbar from "./Navbar";

const Residencies = () => {
  const [residences, setResidences] = useState([]);

  useEffect(() => {
    axios
      .get(API_ROUTES.HOSTELS)
      .then((response) => {
        setResidences(response.data);
      })
      .catch((error) => {
        console.error("Error fetching residences:", error);
      });
  }, []);

  return (
    <>
      <Navbar />
      <div className="mt-24 pt-2 grid grid-cols-1 lg:grid-cols-2 gap-4 h-58.2vh overflow-y-auto">
        {residences.length > 0 ? (
          residences.map((residence) => (
            <Residence key={residence.id} residence={residence} />
          ))
        ) : (
          <p className="text-center text-xl text-red-700 font-bold p-4">
            No Hostels posted yet
          </p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Residencies;
